var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 50 56"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7C7C7C",
    d: "M36.557 11.857C29.227 4.54 24.557 0 24.557 0s-4.68 4.54-11.998 11.857C8.692 15.72 0 25.303 0 34.831c0 6.354 5.15 11.503 11.504 11.503 4.17 0 7.81-2.223 9.827-5.544v.004c.202-.247.533-.451.905-.451.593 0 1.131.417 1.07.935-.444 3.425-2.373 11.87-9.978 14.722h22.45c-7.603-2.852-9.531-11.297-9.97-14.722-.067-.518.475-.935 1.067-.935.363 0 .7.204.904.45l.004-.003a11.457 11.457 0 009.822 5.544c6.348 0 11.504-5.15 11.504-11.503 0-9.528-8.692-19.112-12.552-22.974"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.556 11.88l3.114 9.6h10.097l-8.168 5.934 3.123 9.598-8.166-5.932-8.166 5.932 3.118-9.598-8.17-5.934h10.104l3.114-9.6z"
  })))));
}

SvgPlaceholder.displayName = 'Placeholder';
export default SvgPlaceholder;